<template>
  <div class="swiper-container">
    <div
      class="arrow-box left-arrow"
      @click="previousData"
      :class="{ 'disabled-arrow-box': isScrolledToStart }"
      v-if="!deviceHasTouch"></div>
    <div class="swiper-container-wrapper" ref="dataSwipe" @scroll="handleScrolling">
      <div class="swiper-container-wrapper-row">
        <div v-for="(item, index) in items" :key="index" class="swiper-container-wrapper-row-items">
          <div class="swiper-container-wrapper-row-items-box">
            <slot name="item" :item="item"></slot>
          </div>
        </div>
      </div>
    </div>
    <div
      class="arrow-box right-arrow"
      v-if="!deviceHasTouch"
      @click="nextData"
      :class="{ 'disabled-arrow-box': isScrolledToEnd }"></div>
  </div>
</template>
<script setup lang="ts" generic="T">
import { nextTick, ref, watch } from 'vue';

const props = defineProps<{
  items: T[];
  childrenClass: string;
}>();

const isScrolledToEnd = ref(false);
const isScrolledToStart = ref(true);
const dataSwipe = ref<HTMLElement | null>(null);

const deviceHasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

watch(
  () => props.items,
  () => {
    handleScrolling();
  },
  { immediate: true, deep: true }
);

function nextData() {
  const items = document.querySelectorAll(props.childrenClass);

  if (!dataSwipe.value || items.length === 0) {
    return;
  }

  const itemWidth = (items[0] as HTMLElement).offsetWidth;
  const visibleItems = dataSwipe.value!.clientWidth / itemWidth;

  const currentScrollPosition = Math.round(dataSwipe.value!.scrollLeft / itemWidth);
  const nextPosition = currentScrollPosition + Math.floor(visibleItems);

  dataSwipe.value!.scrollTo({
    left: nextPosition * itemWidth,
    behavior: 'smooth',
  });
}

function previousData() {
  const items = document.querySelectorAll(props.childrenClass);

  if (!dataSwipe.value || items.length === 0) {
    return;
  }

  const itemWidth = (items[0] as HTMLElement).offsetWidth;
  const visibleItems = dataSwipe.value!.clientWidth / itemWidth;

  const currentScrollPosition = Math.round(dataSwipe.value!.scrollLeft / itemWidth);
  const nextPosition = currentScrollPosition - Math.floor(visibleItems);

  dataSwipe.value!.scrollTo({
    left: nextPosition * itemWidth,
    behavior: 'smooth',
  });
}

function handleScrolling() {
  nextTick(() => {
    const items = document.querySelectorAll(props.childrenClass);

    if (items.length === 0 || !dataSwipe.value) {
      isScrolledToEnd.value = true;
      isScrolledToStart.value = true;
      return;
    }

    const scrollLeft = dataSwipe.value.scrollLeft;
    const totalWidth = dataSwipe.value.scrollWidth;
    const containerWidth = dataSwipe.value.clientWidth;

    if (scrollLeft <= 0) {
      isScrolledToStart.value = true;
    } else {
      isScrolledToStart.value = false;
    }
    const nearEndThreshold = 2;
    if (scrollLeft + containerWidth >= totalWidth - nearEndThreshold) {
      isScrolledToEnd.value = true;
    } else {
      isScrolledToEnd.value = false;
    }
  });
}
</script>
